// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Oqa-z","beautyGrouping":"Pqa-z","beautySwatches":"Qqa-z","swatches":"Rqa-z"};